import { render, staticRenderFns } from "./TrackingBox.vue?vue&type=template&id=27b15db5"
import script from "./TrackingBox.vue?vue&type=script&lang=js"
export * from "./TrackingBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports